export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};

export const API_BASE_URL = "/api/v1";

export const API_LOGIN = {
  BASE_URL: "/login",
};

export const API_REGISTER = {
  BASE_URL: "/account",
  CUSTOMER_URL: "/customer",
};

export const API_CONTACTS = {
  BASE_URL: "/contacts",
  QUERY_URL: "/query",
  COUNT_URL: "/count",
};

export const API_COMPANY = {
  BASE_URL: "/company",
  EXTERNAL_LOGIN_URL: "/external-login-url",
  LOGO_URL: "/logo",
  INTEGRATIONS_URL: "/integrations",
  STRIPE_WEBHOOK_REGISTER_URL: "/integrations/stripe/webhook",
};

export const API_SPORTCOURT = {
  BASE_URL: "/sport-courts",
};

export const API_SPORTCOURT_TAX = {
  BASE_URL: "/sport-court-tax",
};

export const API_SCHEDULE_TIME = {
  BASE_URL: "/schedules/free-time",
};

export const API_CUSTOMER_SCHEDULE = {
  BASE_URL: "/customer-schedules",
  QUERY_URL: "/query",
};

export const API_SCHEDULE = {
  BASE_URL: "/schedules",
  QUERY_URL: "/query",
  COUNT_URL: "/count",
};

export const API_SCHEDULE_PLAN = {
  BASE_URL: "/schedule-plans",
  QUERY_URL: "/query",
  SUMMARY_URL: "/summary",
};

export const API_PLAN = {
  BASE_URL: "/plan",
  CREATE_SESSION_URL: "/session",
  GET_CUSTOMER_PORTAL_URL: "/customer-portal",
};

export const APP_SCHEDULE_PLAN = {
  ROUTE: "schedule-plans",
  BASE_PATH: "/main/schedule-plans",
  DETAIL_QUERY_PARAM: "planId",
};

export const buildSchedulePlanDetailPath = (schedulePlanId: string): string =>
  `${APP_SCHEDULE_PLAN.BASE_PATH}?${APP_SCHEDULE_PLAN.DETAIL_QUERY_PARAM}=${encodeURIComponent(
    schedulePlanId
  )}`;

export const API_DASHBOARD = {
  BASE_URL: "/dashboard",
  CUSTOMER_QUANTITY_URL: "customer-quantity",
  WEEKLY_PREDICTED_VALUE_URL: "weekly-predicted-value",
  WEEKLY_PREDICTED_QUANTITY_URL: "weekly-predicted-quantity",
  WEEKLY_SCHEDULE_AVAILABILITY_URL: "weekly-schedule-free",
};

export const API_STORAGE = {
  BASE_URL: "/storage",
  SAVE_REFERENCE_URL: "/save-reference",
};
